import emiter from '@/utils/emiter'
import { Auth, Dict, DictItem } from '@loca/mfe-vue3'

export type HeaderOption = {
  title: string
  value: any
  [key: string]: any
}

// 查询当前页面路由对应字典表的那个选项
function getSelectedTitleOptionIndex(options: any[]) {
  return options.reduce((prev: number, curOption: any, index: number) => {
    const curPath = window.location.pathname
    const curOptionPath = encodeURI(curOption.value)
    if (curOptionPath.indexOf(curPath) === 0) prev = index
    return prev
  }, -1)
}

// 无关的兄弟节点低成本传参用
export const HeaderUtils = {
  equipmentListTitleOptions: [] as any[],

  EVENT_TITLE_OPTIONS: '__POWER-GO-MAIN_EVENT-TITLE-OPTION__',
  EVENT_LEFT_CONTENT: '__POWER-GO-MAIN_EVENT-LEFT-CONTENT__',
  EVENT_LEFT_BACK: '__POWER-GO-MAIN_EVENT-LEFT-BACK__',
  EVENT_RIGHT_VISIBLE: '__POWER-GO-MAIN_EVENT-RIGHT-VISIBLE__',

  clearTitleOptions() {
    emiter.emit(this.EVENT_TITLE_OPTIONS, false)
  },
  setTitleOptions(options: HeaderOption[], defaultIndex: number, callback: any) {
    emiter.emit(this.EVENT_TITLE_OPTIONS, {
      options,
      defaultIndex,
      callback
    })
  },
  onTitleOptionsChange(callback: (payload: any) => void) {
    emiter.on(this.EVENT_TITLE_OPTIONS, callback)
  },

  // 设置左侧自定义内容
  setLeftContent(config: { text: string; onClick?: () => void } | null) {
    emiter.emit(this.EVENT_LEFT_CONTENT, config)
  },

  // 监听左侧内容变化
  onLeftContentChange(callback: (payload: any) => void) {
    emiter.on(this.EVENT_LEFT_CONTENT, callback)
  },

  // 设置左侧返回
  setLeftBack(config: { onClick?: () => void } | null) {
    emiter.emit(this.EVENT_LEFT_BACK, config)
  },

  // 监听左侧返回变化
  onLeftBackChange(callback: (payload: any) => void) {
    emiter.on(this.EVENT_LEFT_BACK, callback)
  },

  // 隐藏 header 右侧区域（如预览全屏时调用）
  hideHeaderRight() {
    emiter.emit(this.EVENT_RIGHT_VISIBLE, false)
  },

  // 恢复 header 右侧区域（如预览关闭时调用）
  showHeaderRight() {
    emiter.emit(this.EVENT_RIGHT_VISIBLE, true)
  },

  // 监听右侧显隐变化
  onRightVisibleChange(callback: (visible: boolean) => void) {
    emiter.on(this.EVENT_RIGHT_VISIBLE, (payload: unknown) => callback(payload === true))
  },

  // 特殊业务场景，专门用于各种设备列表页（移动端）设置顶部下拉标题用
  setEquipmentListTitle() {
    this._setEquipmentListTitleSelect()

    // 更新下拉内容
    Dict.getDict('equipment_list_header_options').then((dict: any) => {
      this.equipmentListTitleOptions = (dict as DictItem[])
        .map((item: DictItem) => ({
          title: item.label,
          value: item.value,
          auth: item.desc
        }))
        .filter((item: any) => Auth.hasPermission(item.auth))

      this._setEquipmentListTitleSelect()
    })
  },

  _setEquipmentListTitleSelect() {
    if (this.equipmentListTitleOptions.length) {
      const index = getSelectedTitleOptionIndex(this.equipmentListTitleOptions)
      this.setTitleOptions(this.equipmentListTitleOptions, index, (option: any) => {
        window.history.replaceState({}, '', option.value)
      })
    }
  }
}
